
import {Component, Prop, Vue} from "vue-property-decorator";
import {formatDate, formatDateTime} from "@/auxillary/date-format";
import {translate} from "@/auxillary/translation";
import {MdbsCore} from "@/api/tsclient";
import {IEventReportRow} from "@/components/safety/EventReportTable.vue";
import EventReportContent from "@/components/safety/EventReportContent.vue";
import IEventReportItemDto = MdbsCore.IEventReportItemDto;

@Component({
  components: {EventReportContent},
  filters: {
    formatDate,
    formatDateTime,
    translate
  }
})
export default class EventReportDetails extends Vue {

  headers: any = [
    {text: 'ReportNr.', value: 'reportNumber', sortable: false, filterable: false, width: "50px"},
    {text: 'Kennung', value: 'identifier', sortable: false, filterable: true},
    {text: 'Event', value: 'eventName', width: "300px", sortable: false, filterable: false},
    {text: 'Erstellt', value: 'creationDate', sortable: true},
    {text: 'Gesendet', value: 'sendDate', sortable: true, divider: true},
    {text: 'Aktiv', value: 'isActive', sortable: false},
    {text: 'Deaktiviert', value: 'isDeactivated', sortable: false},
    {text: 'Signiert', value: 'isSigned', sortable: false},
    {text: 'Meldung', value: 'actions', sortable: false, width: "75px"},
  ];
  options: any = {
    sortBy: ['creationDate'],
    sortDesc: [false]
  };
  footerOptions: any = {
    'items-per-page-options': [-1]
  };

  loading: boolean = false;
  showReportDialog: boolean = false;
  showReportItem: IEventReportRow | null = null;

  @Prop({required: false, default: () => []})
  eventReports: Array<IEventReportItemDto>;

  @Prop({required: false, default: () => ""})
  patientName: string;

  getRowStyle(item: IEventReportRow) {
    // TODO: doesnt work
    return item.sendDate ? 'sent' : '';
  }

  private openReport(item: IEventReportRow) {
    this.showReportItem = item;
    this.showReportDialog = true;
  }
}
